import { Card, Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { TableComponent } from "../../global/TableComponent";
import { TfsSrpYearRatesData } from "../../../helpers/interfaces/TfsSrpYearRatesInterfaces";
import "../../global/dataPage.css";

const { Text } = Typography;

const columns: ColumnsType<TfsSrpYearRatesData> = [
  {
    title: "ID",
    dataIndex: "tfs_srp_year_rate_id",
    key: "tfs_srp_year_rate_id",
    width: 150,
    render: (id) => <Text strong>{id}</Text>,
  },
  {
    title: "MODEL YEAR",
    dataIndex: "model_year",
    key: "model_year",
    render: (year: number) => <Text strong>{year}</Text>,
  },
  {
    title: "DISCOUNT %",
    dataIndex: "discount_percentage",
    key: "discount_percentage",
    width: 200,
    render: (value: number) => (
      <Tag className="data-table-pill">{(Number(value) * 100).toFixed(2)}%</Tag>
    ),
  },
  {
    title: "CREATED DATE",
    dataIndex: "created_at",
    key: "created_at",
    width: 200,
    render: (date: string) => (
      <Text strong>{date ? new Date(date).toLocaleDateString() : "—"}</Text>
    ),
  },
];

export const TfsSrpYearRateTableComponent = ({
  tableProps,
  onPaginationChange,
  onSelectRow,
  selectedRowKey,
}: any) => {
  const meta = tableProps?.data?.meta;
  const data = tableProps?.data?.data;

  if (!meta && !data) {
    return (
      <Card bordered={false} className="data-table-empty">
        <Text type="secondary">No TFS SRP year rates found.</Text>
      </Card>
    );
  }

  return (
    <div className="data-table">
      <TableComponent
        columns={columns}
        data={data}
        pagination={
          meta
            ? {
                current: meta.current_page,
                pageSize: meta.per_page,
                total: meta.total,
                onChange: onPaginationChange,
                showSizeChanger: false,
              }
            : {}
        }
        onSelectRow={onSelectRow}
        selectedRowKey={selectedRowKey}
        selectionType="radio"
      />
    </div>
  );
};
